var utils = require("./utils");
var SPScript = require("spscript");
// returns flat list of terms
var getTerms = exports.getTerms = function(termSetId, ctx) {
    ctx = utils.ensureCtx(ctx);
    return getTermStore(ctx).then(store => {
        var termCollection =store.getTermSet(termSetId).getAllTerms()
        ctx.load(termCollection);
        return utils.executeBatch(ctx).then(() => {
            return utils.collectionToArray(termCollection, Term.fromSPTerm)
        })

    }).catch(() => console.log(arguments));
}

var Term = function() {
    this.name = "",
    this.id = "",
    this.path = "",
    this.childCount = 0;
    this.children = [];
    this.props = {};
    this.sortOrder = 0;
}

Term.fromSPTerm = function(spTerm) {
    var term = new Term();
    if (spTerm) {
        term.name = spTerm.get_name();
        term.id = spTerm.get_id();
        if (term.id._m_guidString$p$0) term.id = term.id._m_guidString$p$0;
        term.path = spTerm.get_pathOfTerm();
        term.childCount = spTerm.get_termsCount();
        term.sortOrder = spTerm.get_customSortOrder() || 0
        term.props = spTerm.get_localCustomProperties();
    }
    return term;
};

// Efficient group algorithm based on sorting by path
var groupTerms = exports.groupTerms = function(flatTerms) {
    var terms = [];
    var activeTerm;
    var sortComp = (a,b) => {
        if (a.path < b.path)  return -1 
        if (a.path > b.path)  return 1 
        return 0;
    }

    var sortedTerms = flatTerms.slice(0).sort(sortComp);
    var i = 0;

    var populateTerm = () => {
        var term = sortedTerms[i];
        //if there isn't a next term return OR if the next term doesn't start with the current term's path
        i = i + 1;
        while(i < sortedTerms.length && sortedTerms[i].path.startsWith(term.path)) {
            term.children.push(populateTerm());
        }
        return term;
    }

    while(i < sortedTerms.length) {
        terms.push(populateTerm())
    }
    return terms;
};

var getTermStore = exports.getTermStore = function(ctx) {
    return SPScript.utils.waitForLibraries(["SP", "SP.ClientContext", "sp_runtime_initialize"])
        .then(() => {
            if (!SPScript.utils.validateNamespace("SP.Taxonomy")) {
                return SPScript.utils.getScript(_spPageContextInfo.webAbsoluteUrl + "/_layouts/15/sp.taxonomy.js");
            }
            return true;
        })
        .then(() => SP.Taxonomy.TaxonomySession.getTaxonomySession(utils.ensureCtx(ctx)).getDefaultSiteCollectionTermStore())
};


// WEBPACK FOOTER //
// ./src/scripts/jsom/mms.js